import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';
import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import {
  DEFAULT_ITEM_SIZE_PX,
  MeasuredSizeVirtualScrollStrategy,
  VirtualItemMeasureDirective,
  provideMeasuredVirtualScroll
} from './virtual-scroll/public-api';
import { ActivatedRoute, Navigation, Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { get } from 'lodash';
import {
  BidItem,
  BidListService,
  ConfigLoadingError,
  Configuration,
  ConfigurationService,
  ConfigurationState,
  FinanceSource,
  FinanceSourceService,
  InventoryService,
  LaunchDarklyService,
  OfferListService,
  OfferListState,
  OfferListTitle,
  Organization,
  OrganizationService,
  PaginationState,
  SenderLists,
  SetBidItemsPerPage,
  UpdateSharedBySenderList,
  UserProfile,
  VDPConfigurationState,
  DateUtilsService,
  DateTimeFormat,
  BidInventoryItem,
  SharedListToggleState,
  LastBidListViewState,
  PersistLastBidListView,
  UpdateSharedListSelectAll,
  UpdateBidListSelectAll,
  AddAllSharedListVehiclesOnPageToSelections,
  AddAllBidListVehiclesOnPageToSelections,
  RemoveAllSharedListVehiclesOnPageFromSelections,
  RemoveAllBidListVehiclesOnPageFromSelections,
  BidListFilterService,
  UpdateSelectedDealership,
  GetDealerships,
  BidListToggleState,
  BidListMultiRemoveResponseDto,
  BidListMultiRemoveRequestDto,
  BidListItemsRemoveFailed,
  VehicleToggleState,
  AddAllVehiclesOnPageToSelections,
  UpdateVehicleSelectAll,
  RemoveAllVehiclesOnPageFromSelections,
  ClearAllSelectedVehiclesUuid,
  SetCurrentVehiclePage,
  CheckboxTogglePage,
  SetBidListDefaultCollapsed,
  SetCurrentUser
} from 'remarketing-angular-library';
import { map, take, takeUntil, tap } from 'rxjs/operators';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { PaginatedBidListService } from '../../services/paginated-bid-list/paginated-bid-list.service';
import { AnalyticsService } from 'smartauction-frontend-micro-library';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { VehiclesService } from '../../services/vehicle-detail/vehicles.service';
import { BidListStateService } from '../../services/bid-list-state-service/bid-list-state.service';
import * as LogRocket from 'logrocket';
import { BuySharedList, CuratedBidListFilter } from '../../enums/filter-values';
import { VehiclePageService } from '../../services/vehicle-page/vehicle-page.service';
import { ErrorModalComponent, ModalPortalDirective } from '@ally/remarketing/shared/ui';
import {
  SharedListToggleService
} from '../../services/shared-list-toggle/shared-list-toggle.service';
import { SharedListMultiActionModalComponent } from '../../../shared/components/offer-modals/shared-list-multi-action-modal/shared-list-multi-action-modal.component';
import {
  SharedListStateService
} from '../../services/shared-list-state-service/shared-list-state.service';
import { MultiOfferActionBannerInfo } from '@ally/remarketing/shared/services';
import { BidListToggleService } from '../../services/bid-list-toggle/bid-list-toggle.service';
import { ActionSubmittingModalComponent, CommonBannerComponent, DropdownSelectComponent, ErrorMessageComponent, PaginationComponent, TrapFocusComponent } from 'remarketing-ui-components-lib';
import { HttpParams } from '@angular/common/http';
import { BidlistActionBarComponent } from '../bidlist-action-bar/bidlist-action-bar.component';
import { AsyncPipe, CommonModule } from '@angular/common';
import { BidlistSortSelectComponent } from '../bidlist-filters/bidlist-sort-select/bidlist-sort-select.component';
import { SharedListActionBarComponent } from '../shared-list-action-bar/shared-list-action-bar.component';
import { BidlistFiltersComponent } from '../bidlist-filters/bidlist-filters.component';
import { SwVehicleContainerHookComponent } from 'src/shared/components/stockwave/sw-vehicle-container-hook/sw-vehicle-container-hook.component';
import { BidlistInventoryItemComponent } from '../bidlist-inventory-item/bidlist-inventory-item.component';
import { ListRowInventoryItemComponent } from '../list-row-inventory-item/list-row-inventory-item.component';
import { VehicleRoutePaths } from '../../../vehicles/vehicleRoutePaths';
import { CommonListTypeService } from '../../../shared/services/common-list-type/common-list-type.service';
import { ModalLauncherService } from './modal-launcher/modal-launcher.service';

export enum ViewType {
  CARD = 'CARD',
  LIST = 'LIST'
}

export interface MultiActionOfferBanners {
  text: string;
  mode: string;
  showIcon: boolean;
  showUndo: boolean;
  showErrorIcon: boolean;
  showSuccessIcon: boolean;
}

export interface BidListMultiRemoveBanners {
  text: string;
  mode: string;
  showIcon: boolean;
  showUndo: boolean;
  showErrorIcon: boolean;
  showSuccessIcon: boolean;
}

@Component({
  selector: 'app-common-list',
  templateUrl: './common-list.component.html',
  styleUrls: ['./common-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    ...provideMeasuredVirtualScroll(DEFAULT_ITEM_SIZE_PX),
    ModalLauncherService
  ],
  imports: [
    TranslocoDirective,
    ActionSubmittingModalComponent,
    SharedListMultiActionModalComponent,
    SharedListMultiActionModalComponent,
    ErrorModalComponent,
    BidlistActionBarComponent,
    TrapFocusComponent,
    DropdownSelectComponent,
    CommonModule,
    AsyncPipe,
    BidlistSortSelectComponent,
    ErrorModalComponent,
    SharedListActionBarComponent,
    SharedListMultiActionModalComponent,
    BidlistActionBarComponent,
    ActionSubmittingModalComponent,
    CommonBannerComponent,
    BidlistFiltersComponent,
    ErrorMessageComponent,
    SwVehicleContainerHookComponent,
    BidlistInventoryItemComponent,
    PaginationComponent,
    ListRowInventoryItemComponent,
    ScrollingModule,
    VirtualItemMeasureDirective,
    ModalPortalDirective
  ]
})
export class CommonListComponent implements OnInit, AfterViewInit {
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(SharedListMultiActionModalComponent) sharedListMultiActionModal: SharedListMultiActionModalComponent;
  @ViewChild('commonList', { static: false }) commonList: ElementRef | CdkVirtualScrollViewport;
  @ViewChild('listTable', { static: false }) listTable;
  @ViewChild(ActionSubmittingModalComponent) actionSubmittingModal: ActionSubmittingModalComponent;
  @ViewChild(ModalPortalDirective) modalOutlet: ModalPortalDirective;
  private readonly destroyed$ = new Subject();
  private readonly window: Window;
  currentTime: string;
  bidItem: BidInventoryItem;
  bidList$: Observable<{ items: BidItem[]; pagination: PaginationState }>;
  private readonly currentNavigation: Navigation;
  private readonly removedUuids = new BehaviorSubject<string[]>([]);
  private readonly SHARED_LIST_DEFAULT_ITEMS_PER_PAGE = 50;
  readonly BIDLIST_MULTI_REMOVE_LIMIT = 50;
  loaderShells = Array(5);
  userToFilterBy: string;
  dealershipCollectionWithProfile: Organization[] = [];
  dealershipCollection: Organization[] = [];
  dealershipFinanceMap = {};
  buyerTipEnabled: boolean;
  configuration: Configuration;
  userProfile: UserProfile;
  translatedObject: any;
  tenantName: string;
  financeSources: FinanceSource[] = [];
  urlBase: string;
  urlBaseExternal = false;
  retainScrollPosition = false;
  isSharedList: boolean;
  isCustomOffer: boolean;
  category: string;
  vehicleListCount: number;
  scrollPosition = 0;
  page = 1;
  sharedList: any;
  userUuid = 'ALL';
  sharedByDropdownFocusTrap = false;
  offerLists: any;
  offerListName = 'All';
  listNameDropdownFocusTrap = false;
  sortOptions = [
    { name: 'Sort 1', value: 1 },
    { name: 'Sort 2', value: 2 },
    { name: 'Sort 3', value: 3 }
  ];
  selectedSharedSenderList$: Observable<SenderLists> = this.store.select(OfferListState.sharedBySenderList);
  sharedListSelectAll = false;
  bidListSelectAll = false;
  vehicleSelectAll = false;
  bidListMultiSelectEnabled = false;
  multiOfferActionSuccess: MultiActionOfferBanners;
  multiOfferActionErrors: MultiActionOfferBanners[];
  bidListMultiRemoveSuccess: BidListMultiRemoveBanners;
  bidListMultiRemoveError: BidListMultiRemoveBanners[] = [];
  isVdpRefactorEnabled = this.getVdpRefactorFlag();

  sharedSender$: Observable<any>;
  sharedByUuid: string;
  offerListUuid: string;
  currentView;
  viewType: string;
  userType = 'BUYER';
  isMobile: boolean;
  showMobileFiltersBtn = true;
  showCloseMobileFiltersBtn = false;
  mobileFilters = false;

  bidlistTranslations = {
    titleBidListEmpty: '',
    titleSharedListEmpty: '',
    titleCustomOfferEmpty: '',
    subTitleVehicle: '',
    subTitleVehicleSharedList: '',
    notAvailableMessage: '',
    sharedListNotAvailable: '',
    customOfferNotAvailable: ''
  };

  bidlistInventoryItemTranslations = {
    feesTooltipAriaLabel: '',
    feesAndTaxesTooltipAriaLabel: '',
    distanceUnit: '',
    color: '',
    headerOdometer: '',
    singleFeeLabel: '',
    singleFeeAmount: '',
    tooltipContent: '',
    feeListSize: '',
    bannerTextSuccesfullyRemoved: '',
    labelEndTime: '',
    labelStartTime: '',
    locationToolTip: '',
    inspectionSeries: '',
    deliveryOptionTooltipMetaTitle: '',
    deliveryOptionTooltipBody: '',
    spreadToBookTooltipMetaTitle: '',
    spreadToBookTooltipTitle: '',
    spreadToBookTooltipBody: '',
    indicatorBodyFirst: '',
    indicatorAriaLabelFirst: '',
    indicatorBodyLast: '',
    indicatorAriaLabelLast: '',
    indicatorBodyOne: '',
    indicatorAriaLabelOne: '',
    highBidderToolTipMetaTitle: '',
    selectedDealershipToolTipMetaTitle: '',
    deliveryStatusIncluded: '',
    deliveryStatusNotIncluded: '',
    deliveryStatusNotAvailable: '',
    transTranslations: '',
    selectPDFtext: '',
    conditionIndicatorTranslations: {},
    textSuccessfullyRemoved: ''
  };

  textBidListMultiRemoveSubmittingTranslation = '';

  @Select(SharedListToggleState.selectedVehicles) sharedListSelectedVehicles$: Observable<string[]>;
  @Select(SharedListToggleState.selectAll) readonly sharedListSelectAllChecked$: Observable<boolean>;
  sharedListVehiclesToggled: string[];
  bidListVehiclesToggled: string[];
  vehiclesToggled: string[];
  @Select(BidListToggleState.selectedVehicles) bidListSelectedVehicles$: Observable<string[]>;
  @Select(BidListToggleState.selectAll) readonly bidListSelectAllChecked$: Observable<boolean>;
  @Select(VehicleToggleState.selectedVehicles) selectedVehicles$: Observable<string[]>;
  @Select(VehicleToggleState.selectAllChecked) readonly selectAllChecked$: Observable<boolean>;
  @Output() selectAllSharedListVehiclesToggled = new EventEmitter<boolean>();
  @Output() selectAllBidListVehiclesToggled = new EventEmitter<boolean>();

  get showShippingQuote(): boolean {
    return this.launchDarklyService.getFeatureFlag('transportationOrderEnabled', false);
  }

  get showDelivery(): boolean {
    return this.launchDarklyService.getFeatureFlag('deliveryEnabled', false);
  }

  get hasItemPendingAction(): boolean {
    return this.sharedListStateService.hasItemPendingAction;
  }

  get showCheckboxColumnForListView(): boolean {
    return (this.isSharedList && this.hasItemPendingAction) || (!this.isSharedList && this.hasRemovableBidListItem);
  }

  get isInspectionSeriesEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('platform-inspectionSeriesEnabled', false);
  }

  constructor(
    private readonly store: Store,
    @Inject('window') window: any,
    private readonly analyticsService: AnalyticsService,
    private readonly inventoryService: InventoryService,
    readonly bidListFilterService: BidListFilterService,
    readonly configurationService: ConfigurationService,
    readonly organizationService: OrganizationService,
    readonly paginatedBidList: PaginatedBidListService,
    readonly financeSourceService: FinanceSourceService,
    private readonly translocoService: TranslocoService,
    readonly bidListStateService: BidListStateService,
    readonly vehicleService: VehiclesService,
    readonly vehiclePageService: VehiclePageService,
    private readonly offerListService: OfferListService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly sharedListToggleService: SharedListToggleService,
    private readonly bidListToggleService: BidListToggleService,
    private readonly sharedListStateService: SharedListStateService,
    private readonly launchDarklyService: LaunchDarklyService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly bidListService: BidListService,
    readonly dateUtilService: DateUtilsService,
    private readonly commonListTypeService: CommonListTypeService,
    private readonly virtualScrollStrategy: MeasuredSizeVirtualScrollStrategy,
    private readonly modalLauncherService: ModalLauncherService
  ) {
    this.window = window as Window;
    this.setValuesFromQueryParams();
    this.bidListFilterService
      .getBidListFilter()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.setupPagination();
      });
    this.vehiclePageService.sharedPageConfig.pipe(takeUntil(this.destroyed$)).subscribe(pageConfig => {
      this.scrollPosition = pageConfig.scrollPosition;
      this.page = pageConfig.page;
    });
  }

  ngOnInit() {
    this.populateDealerships();
    this.checkForPersistentView();
    this.detectIfMobile();
    this.isSharedList = this.bidListStateService.isSharedList;
    this.isCustomOffer = this.commonListTypeService.getVehicleTypeCodeFilterForCurrentSharedList() === 'ACP';
    setTimeout(() => {
      this.analyticsTrackPageLoad();
    }, 500);
    const keyParams = {
      'UIComponents.pagination': {},
      'vehicles.bidListFilter': {},
      'vehicles.sharedLists': {}
    };
    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(take(1))
      .subscribe(translatedObj => {
        this.translatedObject = translatedObj;
      });
    this.getTranslations();
    this.initializeBidList();
    this.subscribeToVehiclePageService();
    this.userProfile = this.store.selectSnapshot(state => state.user.userProfile);

    if (!this.vehicleService.isLeadBuyer) {
      const params = new HttpParams().append('expandFinanceSources', true);
      this.financeSourceService
        .getFinanceSourceList(params)
        .pipe(take(1))
        .subscribe(
          res => {
            this.financeSources = res.data;
          },
          error => {
            console.log(error);
          }
        );
    }

    this.store
      .select(state => state.configuration.configuration.tenantName)
      .pipe(take(1))
      .subscribe(name => {
        this.tenantName = name;
      });

    this.store
      .select(state => state.leadBuyer)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(leadBuyerState => {
        this.dealershipCollection = leadBuyerState.availableDealerships.slice(1);
        this.fetchOrgProfiles();
      });

    this.store
      .select(_state => _state.configuration.configuration)
      .pipe(take(1))
      .subscribe(_configuration => {
        this.configuration = _configuration;
        this.configurationService.getComponent(this.configuration.coreComponents['bid-list']).then(response => {
          this.buyerTipEnabled = response.data.subcomponents['buyer-tips'].visible;
        });
      });

    this.store
      .select(state => state.configuration.coreComponentsConfig)
      .pipe(take(1))
      .subscribe(data => {
        this.urlBase = get(data, 'bid-list.links["vehicle-detail-link"].url');
        this.urlBaseExternal = get(data, 'bid-list.links["vehicle-detail-link"].external');
      });

    this.sharedListSelectedVehicles$.pipe(takeUntil(this.destroyed$)).subscribe(v => {
      this.sharedListVehiclesToggled = v;
    });
    this.sharedListSelectAllChecked$.pipe(takeUntil(this.destroyed$)).subscribe(selectAll => this.sharedListSelectAll = selectAll);
    this.sharedListToggleService.synchronizeSelectAll();

    this.bidListSelectedVehicles$.pipe(takeUntil(this.destroyed$)).subscribe(v => {
      this.bidListVehiclesToggled = v;
    });
    this.bidListSelectAllChecked$.pipe(takeUntil(this.destroyed$)).subscribe(selectAll => this.bidListSelectAll = selectAll);
    this.bidListToggleService.synchronizeSelectAll();

    this.setVehicleToggleSubscricptions();

    this.setSelectAllSharedListVehicles();
    this.setSelectAllBidListVehicles();

    setTimeout(() => { //timeout is necessary since we are working outside of the Angular ngZone
      this.changeDetector.markForCheck();
    }, 1000);
  }

  ngAfterViewInit() {
    this.modalLauncherService.registerOutlet(this.modalOutlet.viewContainerRef);
  }

  detectIfMobile() {
    this.isMobile = window.matchMedia('(max-width: 768px)').matches;
  }

  onResize() {
    this.detectIfMobile();
  }

  showMobileFilters() {
    this.showMobileFiltersBtn = false;
    this.showCloseMobileFiltersBtn = true;
    this.mobileFilters = true;
  }

  hideMobileFilters() {
    this.showMobileFiltersBtn = true;
    this.showCloseMobileFiltersBtn = false;
    this.mobileFilters = false;
  }

  onSharedByOpenChange(isOpen: boolean) {
    this.sharedByDropdownFocusTrap = isOpen;
  }

  onListNameOpenChange(isOpen: boolean) {
    this.listNameDropdownFocusTrap = isOpen;
  }

  evaluateSelectAllCheckbox() {
    this.bidList$.pipe(take(1)).subscribe(result => {
      const auctionItemUuidsOnPage = this.isSharedList ? this.getAuctionItemUuidsForItemsPendingBuyerAction(result.items) : this.getRemovableAuctionItemUuidsForItems(result.items);
      if (auctionItemUuidsOnPage.every(auctionItemUuid => this.vehiclesToggled.includes(auctionItemUuid))) {
        this.store.dispatch(new UpdateVehicleSelectAll(true));
      }
    });
  }

  checkForPersistentView() {
    const state = this.store.selectSnapshot(LastBidListViewState.PreviousView);
    if (state) {
      this.bidItem = state.bidItems;
      this.currentView = state.lastView;
    }
  }

  persistView(viewType: string) {
    this.store.dispatch(new PersistLastBidListView(this.bidItem, viewType));
  }

  get showBidListCardView() {
    return !this.isSharedList && !this.isListView ? true : false;
  }

  get isListView() {
    return this.currentView === ViewType.LIST;
  }

  get virtualScrollEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('bidList-listVirtualizationEnabled', false);
  }

  alignCtaBtns() {
    let style = {};

    if (
      this.bidListMultiSelectEnabled && !this.inServiceOrCustomOffersListEnabled ||
      this.multiVehicleRemovalEnabled && !this.isSharedList ||
      !this.inServiceOrCustomOffersListEnabled
    ) {
      style = { 'justify-content': 'space-between' };
    } else if (
      this.inServiceOrCustomOffersListEnabled && !this.bidListMultiSelectEnabled ||
      !this.bidListMultiSelectEnabled && !this.inServiceOrCustomOffersListEnabled && this.isSharedList
    ) {
      style = { 'justify-content': 'right' };
    } else {
      style = {};
    }

    return style;
  }

  toggleView(viewType: string) {
    this.currentView = viewType;
    this.persistView(viewType);
    if (viewType === 'LIST') {
      setTimeout(() => this.focusListViewHeading(this.listTable.nativeElement.querySelector('.vehicle-title a')), 200);
    } else if (this.virtualScrollEnabled) {
      // #commonList mounts as a fresh CdkVirtualScrollViewport, so the desktop_icon button is not
      // in the DOM yet. A fixed delay can't guarantee the viewport has attached and rendered its
      // first range, so wait for the strategy to confirm the DOM actually reflects it.
      this.virtualScrollStrategy.contentRendered.pipe(take(1), takeUntil(this.destroyed$)).subscribe(() => {
        this.focusTableViewHeading(this.commonListEl?.querySelector('button.desktop_icon'));
      });
    } else {
      setTimeout(() => {
        this.focusTableViewHeading(this.commonListEl?.querySelector('button.desktop_icon'));
      }, 200);
    }
    this.setHasPendingAction();
    this.setHasRemovableBidListItem();
  }

  /** #commonList is a CdkVirtualScrollViewport when virtualization is on, and an ElementRef for the plain <ul> when it is off. */
  get commonListEl(): HTMLElement | undefined {
    if (!this.commonList) return undefined;
    return 'elementRef' in this.commonList ? this.commonList.elementRef.nativeElement : this.commonList.nativeElement;
  }

  // Split out for unit tests
  focusListViewHeading(listViewHeading) {
    listViewHeading.focus();
  }

  focusTableViewHeading(tableViewHeading) {
    tableViewHeading.focus();
  }

  getSenderList() {
    const params = new HttpParams().append('vehicleTypeCode', (this.commonListTypeService.getVehicleTypeCodeFilterForCurrentSharedList() ?? ''))
    this.offerListService
      .getSenderList(params)
      .pipe(take(1))
      .subscribe((senderList: SenderLists[]) => {
        this.setInitialOfferListState(senderList);
        this.selectedSharedSenderList$.pipe(takeUntil(this.destroyed$)).subscribe((sharedSenderList: SenderLists) => {
          const sharedItem: SenderLists = senderList.find(item => sharedSenderList?.userUuid === item.userUuid);
          if (sharedItem?.userUuid) {
            this.userUuid = sharedItem.userUuid;
          } else {
            this.userUuid = 'ALL';
          }
          this.translocoService.selectTranslateObject('vehicles.bidListFilter').pipe(takeUntil(this.destroyed$)).subscribe(translatedObj => {
            const optionsList = [
              { name: translatedObj.allSellers, value: 'ALL', selected: this.userUuid === 'ALL' },
              ...senderList.map(list => {
                return { name: list.userName, value: list.userUuid, selected: this.userUuid === list.userUuid };
              })
            ];
            this.sharedList = [{ options: optionsList }];
            const offerListItem = sharedItem?.offerLists.find(
              offerItem => sharedSenderList?.offerLists[0]?.offerListName === offerItem.offerListName
            );
            if (offerListItem && offerListItem.offerListName) {
              this.offerListName = offerListItem.offerListName;
            } else {
              this.offerListName = 'All';
            }
            if (this.offerListName === 'All' && this.sharedByUuid) {
              this.setBackToAllSenders();
              this.showErrorMessage();
            }
            let optionsListNames = null;
            if (sharedItem?.offerLists && sharedItem.offerLists.length > 0) {
              optionsListNames = [
                { name: translatedObj.allList, value: 'All', selected: this.offerListName === 'All' },
                ...sharedItem.offerLists.map(list => {
                  return { name: list.offerListName, value: list.offerListUuid, selected: this.offerListName === list.offerListName };
                })
              ];
            } else {
              optionsListNames = [
                { name: translatedObj.allList, value: 'ALL', selected: this.offerListName === 'All' }
              ];
            }

            this.offerLists = [{ options: optionsListNames }];
            this.changeDetector.markForCheck();
          });

          this.setupPagination();
          this.clearQueryParamValues();
        });
      });
  }

  setInitialOfferListState(senderLists) {
    if (this.sharedByUuid && this.offerListUuid) {
      const sharedItem: SenderLists = senderLists.find(item => this.sharedByUuid === item.userUuid);
      if (sharedItem?.offerLists) {
        const offerList = sharedItem.offerLists.find(list => {
          return list.offerListUuid === this.offerListUuid;
        });
        if (offerList) {
          const selectedSenderList = {
            offerLists: [offerList],
            userUuid: this.sharedByUuid,
            userName: sharedItem.userName
          } as SenderLists;
          this.store.dispatch(new UpdateSharedBySenderList(selectedSenderList));
        }
      }
    }
    this.resetSelectedVehicles();
  }

  sharedBySelection(sharedListItem) {
    const dataSet = get(sharedListItem, 'dataset');
    if (dataSet && dataSet.value) {
      const titleObj: SenderLists = {
        userName: dataSet.name,
        userUuid: dataSet.value,
        offerLists: [{ offerListName: BuySharedList.LIST_NAME, offerListUuid: null }]
      };
      this.store.dispatch(new UpdateSharedBySenderList(titleObj));
      this.resetSelectedVehicles();
    }
  }

  listNameSelection(listName) {
    const dataSet = get(listName, 'dataset');
    if (dataSet && dataSet.value) {
      const titleObj: OfferListTitle = { offerListName: dataSet.name, offerListUuid: dataSet.value };
      let sharedBySenderList: SenderLists = this.store.selectSnapshot(OfferListState.sharedBySenderList);
      sharedBySenderList = { ...sharedBySenderList, offerLists: [titleObj] };
      this.store.dispatch(new UpdateSharedBySenderList(sharedBySenderList));
      this.resetSelectedVehicles();
    }
  }

  resetSelectedVehicles() {
    // Only need to call the dispatch for vehicleToggle,
    // since it doesn't have the same unecessary states and calls as the previosu implementation.
    this.store.dispatch(new ClearAllSelectedVehiclesUuid());
    this.bidListToggleService.reset();
    this.sharedListToggleService.reset();
  }

  review(result) {
    if (result.reviewed) {
      this.inventoryService
        .unmarkReviewed(result.inventoryItemUuid)
        .pipe(takeUntil(this.destroyed$))
        .subscribe();
    } else {
      this.inventoryService
        .markReviewed(result.inventoryItemUuid)
        .pipe(takeUntil(this.destroyed$))
        .subscribe();
    }
  }

  trackById(index: number, item: BidItem) {
    return item.inventoryItemUuid;
  }

  initializeBidList() {
    this.refreshTime();
    if (this.isSharedList) {
      this.getSenderList();
    } else {
      this.setupPagination();
    }
  }

  refreshBidList() {
    this.scrollPosition = 0;
    this.refreshTime();
    this.paginatedBidList.disconnect();

    Promise.resolve().then(() => {
      this.setupPagination();
      this.resetSelectedVehicles();
      this.changeDetector.markForCheck();
    });
  }

  refreshTime() {
    this.configurationService
      .getConfiguration()
      .then(response => {
        const config = response.data;
        this.currentTime = `${this.dateUtilService.formatDate(config.system.currentSystemDate, DateTimeFormat.H_MM_A)}`;
      })
      .catch(error => {
        this.store.dispatch(new ConfigLoadingError());
      });
  }

  setScrollPosition() {
    const scrollPostion = get(this.currentNavigation, 'extras.state.scrollPosition', 0);
    this.window.scrollTo({ top: scrollPostion });
  }

  changePage(page: number) {
    this.scrollPosition = 0;
    this.paginatedBidList.goToPage(page);
    this.window.requestAnimationFrame(() => {
      this.window.scrollTo({ top: 0 });
    });
    this.sharedListSelectAll = false;
    this.bidListSelectAll = false;
    this.store.dispatch(new UpdateVehicleSelectAll(false));
  }

  changePerPage(perPage: number) {
    this.paginatedBidList.setPerPage(perPage);
    this.store.dispatch(new SetBidItemsPerPage(perPage));
    this.resetSelectedVehicles();
  }

  getDefaultItemsPerPage(itemsPerPage: number) {
    return this.isSharedList ? this.SHARED_LIST_DEFAULT_ITEMS_PER_PAGE : itemsPerPage;
  }

  setVehicleCheckboxPage() {
    this.store.dispatch(this.isSharedList ? new SetCurrentVehiclePage(CheckboxTogglePage.SHARED_LIST) : new SetCurrentVehiclePage(CheckboxTogglePage.BID_LIST));
  }

  setupPagination() {
    let previousItems = [];
    this.setHasDealerAndListNameSpecified();
    this.setVehicleCheckboxPage();
    this.category = this.setListView();
    const { bidListPagination, bidListSort } = this.store.selectSnapshot(VDPConfigurationState.currentUserState);
    const { state$, items$ } = this.connectPaginatedBidList(bidListPagination, bidListSort);

    this.bidList$ = combineLatest([items$, state$, this.removedUuids]).pipe(
      tap(([_, pagination]) => {
        if (pagination.loadingState === 'loading') {
          this.loaderShells = Array(pagination.itemsPerPage);
        }
      }),
      map(([items, pagination, uuids]) => {
        const updatedPagination = {
          ...pagination,
          totalItems: pagination.totalItems - uuids.length
        } as PaginationState;
        return [items, updatedPagination];
      }),
      map(([items, pagination]: [BidItem[], PaginationState]) => ({ items, pagination })),
      tap(({ items }) => {
        this.virtualScrollStrategy.setItemKeys((items ?? []).map(item => item.inventoryItemUuid));
      }),
      tap(({ items, pagination }) => {
        if (items && !this.isVehicleListsSame(previousItems, items) && pagination.loadingState === 'success' && Array.isArray(items) && items.length) {
          this.updateVehicleListCount(items, pagination);
          previousItems = [...items];
        } else if (pagination.loadingState === 'success') {
          this.updateVehicleListCount(items, pagination);
        }
        if (pagination.loadingState === 'success' && !this.hasCheckboxActionOverridingScroll && !this.retainScrollPosition) {
          this.setScrollPosition();
        }

        if (pagination.loadingState === 'success') {
          this.vehiclePageService.allowRefresh();
        }
        this.retainScrollPosition = false;
        this.sharedListToggleService.hasCheckboxActionOverridingScroll = false;
        this.bidListToggleService.hasCheckboxActionOverridingScroll = false;
      })
    );
  }

  connectPaginatedBidList(bidListPagination, bidListSort) {
    return this.paginatedBidList.connect({
      itemsPerPage: bidListPagination ? this.getDefaultItemsPerPage(bidListPagination.itemsPerPage) : null,
      page: this.page,
      sortOrder: bidListSort ? bidListSort.sortOrder : null,
      sortBy: bidListSort ? bidListSort.sortBy : null,
      providerName: bidListSort ? bidListSort.providerName : null,
      providerValue: bidListSort ? bidListSort.providerValue : null,
      addedByUuid: bidListSort ? bidListSort.addedByUuid : null,
      status: bidListSort ? bidListSort.bidListStatus : null,
      filter: {
        category: this.category,
        offerListSenderUserUuid: this.userUuid !== 'ALL' ? this.userUuid : null,
        offerListUuid: this.offerListUuid !== 'All' ? this.offerListUuid : null
      }
    });
  }

  isVehicleListsSame(vehicleList1, vehicleList2) {
    return (vehicleList1.length === vehicleList2.length) && vehicleList1.every((vehicle, index) => vehicle.inventoryItemUuid === vehicleList2[index].inventoryItemUuid);
  }

  updateVehicleListCount(items, pagination) {
    if (items && items.length > 0) {
      this.vehicleListCount = pagination.totalItems;
    } else {
      this.vehicleListCount = 0;
    }
  }

  analyticsTrackPageLoad() {
    const tenantSite = this.store.selectSnapshot(ConfigurationState.configuration).tenantName;
    this.analyticsService.trackPageLoad({
      page: {
        section: 'Buy',
        subsection: `${this.commonListTypeService.getCommonListName()}`,
        pageName: `${tenantSite}:Buy:${this.commonListTypeService.getCommonListName()}`,
      }
    });
  }

  fetchFinanceSource(oeUuid: string) {
    this.financeSourceService
      .getFinanceSourceListByOeUuid(oeUuid)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(res => {
        this.dealershipFinanceMap[oeUuid] = res;
        this.financeSources = this.financeSources.concat(this.dealershipFinanceMap[oeUuid]).filter((obj, index, self) => {
          return self.findIndex((item) => item.financeSourceUuid === obj.financeSourceUuid) === index;
        });
        // This component is OnPush; without marking dirty here, rows that already rendered before
        // this response arrived (notably list view, which renders once and isn't virtualized) never
        // get the updated dealershipFinanceMap/financeSources pushed into their inputs.
        this.changeDetector.markForCheck();
      });
  }

  fetchOrgProfiles() {
    for (const dealer of this.dealershipCollection) {
      this.organizationService
        .getOrganization(dealer.oeUuid)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(response => {
          this.dealershipCollectionWithProfile.push(response);
          this.fetchFinanceSource(response.oeUuid);
          this.changeDetector.markForCheck();
        });
    }
  }

  ngOnDestroy() {
    this.store.dispatch(new UpdateSharedListSelectAll(false));
    this.store.dispatch(new UpdateBidListSelectAll(false));
    this.store.dispatch(new UpdateVehicleSelectAll(false));
    this.destroyed$.next(true);
    this.destroyed$.complete();
    this.paginatedBidList.disconnect();
  }

  get allCollapsed(): boolean {
    return this.store.selectSnapshot(VDPConfigurationState.currentUserState).bidListDefaultCollapsed !== false;
  }

  /**
   * Collapses or expands every row, including rows this client has never rendered.
   *
   * Heights are invalidated before the dispatch so the cached mean is captured while it still
   * describes the outgoing state. Scrolling to the top is deliberate: every row changes height at
   * once, so there is no anchor item left to hold the viewport against.
   */
  toggleCollapseState(collapsed: boolean) {
    this.virtualScrollStrategy.invalidateHeights();
    this.store.dispatch(new SetCurrentUser());
    this.store.dispatch(new SetBidListDefaultCollapsed(collapsed));
    this.virtualScrollStrategy.scrollToIndex(0, 'auto');
  }

  setListView() {
    if (this.isSharedList) {
      return CuratedBidListFilter.SHARED_LIST;
    } else {
      return CuratedBidListFilter.BID_LIST;
    }
  }

  get isLegacyBidlistLinkEnabled() {
    return this.vehicleService.islegacyBidlistLinkEnabled;
  }

  redirectToLegacyBidlist() {
    console.log('Return to Legacy Bidlist button clicked, firing custom event');
    LogRocket.track('redirectToLegacyBidlist');
    setTimeout(() => {
      this.navigateTo('/sa-web/faces/pages/dealer/buyer/bidList.jsp');
    }, 500);
  }

  navigateTo(url: string) {
    window.location.href = url;
  }

  remove(auctionItemUuid: string) {
    this.retainScrollPosition = true;
    this.removedUuids.next([...this.removedUuids.getValue(), auctionItemUuid]);
  }

  undo(auctionItemUuid: string) {
    const uuids = this.removedUuids.getValue();
    const index = uuids.findIndex(uuid => uuid === auctionItemUuid);
    this.removedUuids.next([...uuids.slice(0, index), ...uuids.slice(index + 1)]);
  }

  subscribeToVehiclePageService() {
    this.vehiclePageService.refreshBidList$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.refreshBidList();
      });
  }

  getFromQueryParam(param: string): string {
    return this.route.snapshot.queryParamMap.get(param);
  }

  setValuesFromQueryParams() {
    this.sharedByUuid = this.getFromQueryParam('sharedBy');
    this.offerListUuid = this.getFromQueryParam('offerListUuid');
  }

  clearQueryParamValues() {
    this.sharedByUuid = undefined;
    this.offerListUuid = undefined;
    this.router.navigate([], {
      queryParams: { sharedBy: null, offerListUuid: null },
      queryParamsHandling: 'merge'
    });
  }

  showErrorMessage() {
    this.updateNotAvailableTranslation();
    this.errorModal.message = this.bidlistTranslations.notAvailableMessage;
    this.errorModal.btnCloseAlignCenter = true;
    this.errorModal.show();
  }

  setBackToAllSenders() {
    this.userUuid = 'ALL';
    this.sharedList.find(item => {
      item.options.forEach(option => {
        option.selected = option.value === 'ALL';
      });
    });
    const restSenderLists: SenderLists = { userName: null, userUuid: null, offerLists: null };
    this.store.dispatch(new UpdateSharedBySenderList(restSenderLists));
  }

  get isUserSelected(): boolean {
    return this.userUuid !== 'ALL';
  }

  setVehicleToggleSubscricptions() {
    this.selectedVehicles$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(v => this.vehiclesToggled = v);
    this.selectAllChecked$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(selectAll => this.vehicleSelectAll = selectAll);
  }

  setSelectAllSharedListVehicles() {
    this.sharedListToggleService.makeSelectAllCheckboxActive.pipe(take(1)).subscribe(selectAll => {
      this.sharedListSelectAll = selectAll;
    });
  }

  setSelectAllBidListVehicles() {
    this.bidListToggleService.makeSelectAllCheckboxActive.pipe(take(1)).subscribe(selectAll => {
      this.bidListSelectAll = selectAll;
    });
  }

  handleSelectAllSharedListVehiclesClick(event: Event) {
    this.sharedListToggleService.hasCheckboxActionOverridingScroll = true;
    const target = (event.target as unknown) as HTMLInputElement;
    this.sharedListSelectAll = target.checked;
    this.analyticsService.trackEvent('checkbox', 'Select all vehicles - ' + this.sharedListSelectAll);
    this.bidList$.pipe(take(1)).subscribe(result => {
      const currentResponseAuctionItemUuids = this.getAuctionItemUuidsForItemsPendingBuyerAction(result.items);
      if (this.commonMultiCheckboxImplementationEnabled) {
        this.toggleSelectAllVehicleToggle(currentResponseAuctionItemUuids);
      } else if (this.sharedListSelectAll) {
        this.store.dispatch(new AddAllSharedListVehiclesOnPageToSelections(currentResponseAuctionItemUuids));
        this.sharedListToggleService.multipleVehicleToggle(currentResponseAuctionItemUuids);
      } else {
        this.store.dispatch(new RemoveAllSharedListVehiclesOnPageFromSelections(currentResponseAuctionItemUuids));
        this.sharedListToggleService.multipleVehicleUnToggle(currentResponseAuctionItemUuids);
      }
    });
  }

  getAuctionItemUuidsForItemsPendingBuyerAction(bidList): string[] {
    if (bidList) {
      const reducedBidList = bidList.reduce((items, item) => {
        if (item.buyerAuctionItemStatus === 'PENDING_BUYER_ACTION') {
          items.push(item);
        }
        return items;
      }, []);
      return reducedBidList.map(item => item.auctionItemUuid);
    }
    return [];
  }

  isSharedListVehicleToggled(auctionItemUuid: string) {
    return this.sharedListVehiclesToggled.some(v => v === auctionItemUuid);
  }

  isVehicleToggled(auctionItemUuid: string) {
    return this.vehiclesToggled.some(v => v === auctionItemUuid);
  }

  setHasDealerAndListNameSpecified() {
    this.sharedListStateService.hasDealerAndListNameSpecified = (this.userUuid !== 'ALL' && this.offerListName !== 'All');
  }

  setHasPendingAction() {
    this.bidList$.pipe(take(1)).subscribe(result => {
      result.items.forEach(item => {
        if (item.buyerAuctionItemStatus === 'PENDING_BUYER_ACTION' || item.buyerAuctionItemStatus === 'PENDING_SELLER_ACTION') {
          this.sharedListStateService.hasItemPendingAction = true;
        }
      });
    });
  }

  get isOfferListBuyerSelectAllEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('offerlist-buyer-selectAllEnabled', true);
  }

  get commonMultiCheckboxImplementationEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('commonMultiCheckboxImplementationEnabled', false);
  }

  get isSelectAllChecked(): boolean {
    if (this.commonMultiCheckboxImplementationEnabled) {
      return this.vehicleSelectAll;
    } else if (this.isSharedList) {
      return this.sharedListSelectAll;
    } else {
      return this.bidListSelectAll;
    }
  }

  showMultiActionModal(action: string) {
    this.setSelectedFinanceSourcesForModal();
    this.bidList$.pipe(take(1)).subscribe(result => {
      this.sharedListMultiActionModal.setPlatformSpareKeyFee(result.pagination?.metaData?.platformSpareKeyFee);
      this.sharedListMultiActionModal.show(action, result.items.filter(item => this.commonMultiCheckboxImplementationEnabled ?
        this.isVehicleToggled(item.auctionItemUuid) : this.isSharedListVehicleToggled(item.auctionItemUuid)));
    });
  }

  setSelectedFinanceSourcesForModal() {
    let financeSourceUuids: string[] = [];
    this.bidList$.pipe(take(1)).subscribe(result => {
      financeSourceUuids = result.items.filter(item => this.commonMultiCheckboxImplementationEnabled ?
        this.isVehicleToggled(item.auctionItemUuid) : this.isSharedListVehicleToggled(item.auctionItemUuid)).map(item => item.financeSourceUuid);
    });
    this.sharedListMultiActionModal.setSelectedFinanceSources(this.financeSources
      .filter(financeSource => (financeSource.feeAmount !== undefined && financeSource.feeAmount !== null && financeSource.feeAmount !== 0) &&
        financeSourceUuids.includes(financeSource.financeSourceUuid)));
  }

  createBanners(event: MultiOfferActionBannerInfo) {
    this.clearMultiActionBanners();
    this.resetSelectedVehicles();
    this.sharedListMultiActionModal.close();
    this.setMultiActionBanner(event);
  }

  setMultiActionBanner(multiOfferBanners: MultiOfferActionBannerInfo) {
    this.translocoService.selectTranslateObject(multiOfferBanners.translationCodeMapping).pipe(take(1)).subscribe((translate) => {
      if (multiOfferBanners.successPresent) {
        this.multiOfferActionSuccess = {
          text: translate.pop(),
          showErrorIcon: false,
          showIcon: true,
          showUndo: false,
          showSuccessIcon: true,
          mode: 'confirmation'
        };
        this.analyticsService.track('impressionEvent',
          {
            name: this.analyticsMessageReference('ConfirmationMessageEvent'),
            contents: [{
              'name': this.analyticsMessageReference('ConfirmationSuccessMessageEvent'),
              'message': this.multiOfferActionSuccess.text,
              'attributes': {
              },
            }]
          });
      }
      this.multiOfferActionErrors = translate.map((errorText: string) => {
        this.analyticsService.track('impressionEvent',
          {
            name: this.analyticsMessageReference('ConfirmationMessageEvent'),
            contents: [{
              'name': this.analyticsMessageReference('ConfirmationErrorMessageEvent'),
              'message': errorText,
              'attributes': {
              },
            }]
          });
        return {
          text: errorText,
          showErrorIcon: true,
          showIcon: true,
          showUndo: false,
          showSuccessIcon: false,
          mode: 'confirmation'
        };
      });
    }, error => {
      console.log(error);
    });
  }

  clearMultiActionBanners() {
    this.multiOfferActionSuccess = null;
    this.multiOfferActionErrors = [];
  }

  closeSuccessBanner() {
    this.multiOfferActionSuccess = null;
  }

  closeErrorBanner(index) {
    this.multiOfferActionErrors.splice(index, 1);
  }

  private getOrganization(): Organization {
    return this.store.selectSnapshot(state => state.org.organization) as Organization;
  }
  // Added to fix deeplink issues with the Modal.
  populateDealerships() {
    if (!this.vehicleService.isLeadBuyer) {
      // set Default Dealership for non-lead buyers
      this.store.dispatch(new UpdateSelectedDealership(this.getOrganization()));
    } else {
      if (this.store.snapshot().leadBuyer.availableDealerships.length < 1) {
        this.store.dispatch(new GetDealerships(true));
      }
    }
  }

  analyticsMessageReference(confirmMessage: string) {
    if (this.inServiceVehicleEnabled || this.customOffersEnabled) {
      if (this.router.url.includes(VehicleRoutePaths.IN_SERVICE)) {
        return 'inService' + confirmMessage;
      } else if (this.router.url.includes(VehicleRoutePaths.CUSTOM_OFFERS)) {
        return 'customOffers' + confirmMessage;
      }
      return 'inService' + confirmMessage;
    } else {
      return 'cbl' + confirmMessage;
    }
  }

  getTranslations() {
    const keyParams = {
      'shared': {},
      'common': {},
      'vehicles': {},
      'UIComponents': {},
      'offerList': {}
    };

    this.translocoService.selectTranslateObject(keyParams).pipe(takeUntil(this.destroyed$)).subscribe((translation: any[]) => {
      this.bidlistInventoryItemTranslations.feesTooltipAriaLabel = translation[0].feeTooltipModal.textMoreInformationAriaLabelFees;
      this.bidlistInventoryItemTranslations.feesAndTaxesTooltipAriaLabel = translation[0].feeTooltipModal.textMoreInformationAriaLabelFeesAndTaxes;

      this.bidlistInventoryItemTranslations.distanceUnit = translation[1].distanceUnit;
      this.bidlistInventoryItemTranslations.color = translation[1].color;

      this.bidlistInventoryItemTranslations.labelEndTime = translation[2].bidlistInventoryItem.labelauctionStatusTime.endTime;
      this.bidlistInventoryItemTranslations.labelStartTime = translation[2].bidlistInventoryItem.labelauctionStatusTime.startTime;
      this.bidlistInventoryItemTranslations.locationToolTip = translation[2].bidlistInventoryItem.tooltipLocation.metaTitle;
      this.bidlistInventoryItemTranslations.deliveryOptionTooltipMetaTitle = translation[2].bidlistInventoryItem.locationDeliveryOption.metaTitle;
      this.bidlistInventoryItemTranslations.deliveryOptionTooltipBody = translation[2].bidlistInventoryItem.locationDeliveryOption.body;
      this.bidlistInventoryItemTranslations.spreadToBookTooltipMetaTitle = translation[2].bidlistInventoryItem.tooltipSpreadToBook.metaTitle;
      this.bidlistInventoryItemTranslations.spreadToBookTooltipTitle = translation[2].bidlistInventoryItem.tooltipSpreadToBook.title;
      this.bidlistInventoryItemTranslations.spreadToBookTooltipBody = translation[2].bidlistInventoryItem.tooltipSpreadToBook.body;
      this.bidlistInventoryItemTranslations.indicatorBodyFirst = translation[2].bidlistInventoryItem.tooltipTimeIndicator.indicatorFirstDay;
      this.bidlistInventoryItemTranslations.indicatorAriaLabelFirst = translation[2].bidlistInventoryItem.tooltipTimeIndicator.ariaLabelFirstDay;
      this.bidlistInventoryItemTranslations.indicatorBodyLast = translation[2].bidlistInventoryItem.tooltipTimeIndicator.indicatorLastDay;
      this.bidlistInventoryItemTranslations.indicatorAriaLabelLast = translation[2].bidlistInventoryItem.tooltipTimeIndicator.ariaLabelLastDay;
      this.bidlistInventoryItemTranslations.indicatorBodyOne = translation[2].bidlistInventoryItem.tooltipTimeIndicator.indicatorOneDay;
      this.bidlistInventoryItemTranslations.indicatorAriaLabelOne = translation[2].bidlistInventoryItem.tooltipTimeIndicator.ariaLabelOneDay;
      this.bidlistInventoryItemTranslations.highBidderToolTipMetaTitle = translation[2].bidlistInventoryItem.toolTipHighBidder.metaTitle;
      this.bidlistInventoryItemTranslations.deliveryStatusIncluded = translation[2].bidlistInventoryItem.textYes;
      this.bidlistInventoryItemTranslations.deliveryStatusNotIncluded = translation[2].bidlistInventoryItem.textNo;
      this.bidlistInventoryItemTranslations.deliveryStatusNotAvailable = translation[2].bidlistInventoryItem.not;
      this.bidlistInventoryItemTranslations.headerOdometer = translation[2].sharedListsListView.headerOdometer;
      this.bidlistInventoryItemTranslations.selectedDealershipToolTipMetaTitle = translation[2].bidlistInventoryItem.toolTipSelectedDealership.metaTitle;

      this.bidlistInventoryItemTranslations.transTranslations = translation[3].transportationEstimate;
      this.bidlistInventoryItemTranslations.deliveryStatusNotAvailable = translation[3].optionAccessories.textNA;
      this.bidlistInventoryItemTranslations.selectPDFtext = translation[3].appBuyerTooltip.selectPDFtext;
      this.bidlistInventoryItemTranslations.conditionIndicatorTranslations = translation[3].conditionIndicatorTranslations;

      this.bidlistInventoryItemTranslations.inspectionSeries = translation[4].general.inspectionSeries;

      this.textBidListMultiRemoveSubmittingTranslation = translation[2].bidList.textBidListMultiRemoveSubmitting;

      this.bidlistTranslations.titleBidListEmpty = translation[2].bidList.titleBidListEmpty;
      this.bidlistTranslations.titleSharedListEmpty = translation[2].bidList.titleSharedListEmpty;
      this.bidlistTranslations.titleCustomOfferEmpty = translation[2].bidList.titleCustomOfferEmpty;
      this.bidlistTranslations.subTitleVehicle = translation[2].bidList.subTitleVehicle;
      this.bidlistTranslations.subTitleVehicleSharedList = translation[2].bidList.subTitleVehicleSharedList;

      this.bidlistTranslations.sharedListNotAvailable = translation[4].sharedListNotAvailableMessage;
      this.bidlistTranslations.customOfferNotAvailable = translation[4].customOffers.notAvailableMessage;
      this.bidlistTranslations.notAvailableMessage = this.bidlistTranslations.sharedListNotAvailable;
    });
  }

  updateNotAvailableTranslation() {
    this.bidlistTranslations.notAvailableMessage = this.isCustomOffer
      ? this.bidlistTranslations.customOfferNotAvailable : this.bidlistTranslations.sharedListNotAvailable;
  }

  get multiVehicleRemovalEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('bidlist-buyer-selectRemoveEnabled', false);
  }

  get inServiceVehicleEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('platform-inServiceVehiclesEnabled', false);
  }

  get customOffersEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('offerlist-avisCustomOfferEnabled', false);
  }

  get inServiceOrCustomOffersListEnabled(): boolean {
    return this.inServiceVehicleEnabled || this.customOffersEnabled;
  }

  isBidListVehicleToggled(auctionItemUuid: string) {
    return this.bidListVehiclesToggled.some(v => v === auctionItemUuid);
  }

  handleSelectAllBidListVehiclesClick(event: Event) {
    this.bidListToggleService.hasCheckboxActionOverridingScroll = true;
    const target = (event.target as unknown) as HTMLInputElement;
    this.bidListSelectAll = target.checked;
    this.selectAllBidListVehiclesToggle();
  }

  toggleSelectAllVehicleToggle(items: string[]) {
    if (this.vehicleSelectAll) {
      this.store.dispatch(new RemoveAllVehiclesOnPageFromSelections(items));
    } else {
      if (!this.isSharedList) {
        items = this.filterSelectedBidItemsVehicles(items);
      }
      this.store.dispatch(new AddAllVehiclesOnPageToSelections(items));
    }
  }

  selectAllBidListVehiclesToggle() {
    this.bidList$.pipe(take(1)).subscribe(result => {
      let currentResponseAuctionItemUuids = this.getRemovableAuctionItemUuidsForItems(result.items);
      if (this.commonMultiCheckboxImplementationEnabled) {
        this.toggleSelectAllVehicleToggle(currentResponseAuctionItemUuids);
      } else if (this.bidListSelectAll) {
        currentResponseAuctionItemUuids = this.filterSelectedBidItems(currentResponseAuctionItemUuids);
        this.store.dispatch(new AddAllBidListVehiclesOnPageToSelections(currentResponseAuctionItemUuids));
        this.bidListToggleService.multipleVehicleToggle(currentResponseAuctionItemUuids);
      } else {
        this.store.dispatch(new RemoveAllBidListVehiclesOnPageFromSelections(currentResponseAuctionItemUuids));
        this.bidListToggleService.multipleVehicleUnToggle(currentResponseAuctionItemUuids);
      }
    });
  }

  filterSelectedBidItems(auctionItemUuids: string[]) {
    const toggledVehicles = this.store.selectSnapshot(state => state.bidListToggle.selectedVehicles);
    const filteredAuctionItemUuids = auctionItemUuids.filter(item => !toggledVehicles.includes(item));
    return filteredAuctionItemUuids.slice(0, BidListToggleService.BIDLIST_MULTI_REMOVE_LIMIT - toggledVehicles.length);
  }

  filterSelectedBidItemsVehicles(auctionItemUuids: string[]) {
    const filteredAuctionItemUuids = auctionItemUuids.filter(item => !this.vehiclesToggled.includes(item));
    return filteredAuctionItemUuids.slice(0, this.BIDLIST_MULTI_REMOVE_LIMIT - this.vehiclesToggled.length);
  }

  isRemovableBidListItem(buyerAuctionItemStatus, auctionItemStatus): boolean {
    return !(buyerAuctionItemStatus === 'PENDING_BUYER_ACTION'
      || buyerAuctionItemStatus === 'PENDING_SELLER_ACTION'
      || buyerAuctionItemStatus === 'LEADING'
      || buyerAuctionItemStatus === 'PENDING_BID'
      || buyerAuctionItemStatus === 'WON'
      || auctionItemStatus === 'SOLD'
      || auctionItemStatus === 'HOLD'
      || auctionItemStatus === 'REMOVED');
  }

  get hasRemovableBidListItem(): boolean {
    return this.bidListStateService.hasRemovableBidListItem;
  }

  setHasRemovableBidListItem() {
    if (!this.isSharedList) {
      this.bidList$.pipe(take(1)).subscribe(result => {
        result.items.forEach(item => {
          if (this.isRemovableBidListItem(item.buyerAuctionItemStatus, item.auctionItemStatus)) {
            this.bidListStateService.hasRemovableBidListItem = true;
          }
        });
      });
    }
  }

  getRemovableAuctionItemUuidsForItems(bidList): string[] {
    const removedBidListItems = this.removedUuids.getValue();
    if (bidList) {
      const reducedBidList = bidList.reduce((items, item) => {
        if (this.isRemovableBidListItem(item.buyerAuctionItemStatus, item.auctionItemStatus) && !removedBidListItems.includes(item.auctionItemUuid)) {
          items.push(item);
        }
        return items;
      }, []);
      return reducedBidList.map(item => item.auctionItemUuid);
    }
    return [];
  }

  get hasCheckboxActionOverridingScroll(): boolean {
    if (this.commonMultiCheckboxImplementationEnabled) {
      return this.vehiclesToggled.length > 0;
    }
    return (this.isSharedList && this.sharedListToggleService.hasCheckboxActionOverridingScroll)
      || (!this.isSharedList && this.bidListToggleService.hasCheckboxActionOverridingScroll);
  }

  bidListMultiRemoveSubmit(action: string) {
    if (action === 'REMOVE') {

      this.actionSubmittingModal.show();

      const auctionItemUuids = this.commonMultiCheckboxImplementationEnabled ? this.vehiclesToggled : this.bidListToggleService.snapShot().selectedVehicles;

      const bidListMultiRemoveRequestDto = { auctionItemUuids: auctionItemUuids } as BidListMultiRemoveRequestDto;
      this.bidListService.bidListMultiRemove(bidListMultiRemoveRequestDto)
        .pipe(take(1))
        .subscribe((response: BidListMultiRemoveResponseDto) => {

          this.resetSelectedVehicles();

          const numFailedAuctionItems = response ? response.removalFailedList.length : 0;
          this.setBidListMultiRemoveSuccessBanner(auctionItemUuids.length - numFailedAuctionItems);

          const failedAuctionItemUuids = new Set<string>();
          response.removalFailedList.forEach((failedAuctionItem: BidListItemsRemoveFailed) => {
            failedAuctionItemUuids.add(failedAuctionItem.auctionItemUuid);
          });

          for (const auctionItemUuid of auctionItemUuids) {
            // update pagination as to not fall out of bounds
            if (!failedAuctionItemUuids.has(auctionItemUuid)) {
              this.remove(auctionItemUuid);
            }
          }

          if (numFailedAuctionItems > 0) {
            // loop through failed auction items and generate banners based on the type of error received.
            this.setBidListMultiRemoveErrorBanners(response);
          }

          this.analyticsVehiclesRemoved(auctionItemUuids.filter(auctionItemUuid => {
            return !failedAuctionItemUuids.has(auctionItemUuid);
          }));

          this.actionSubmittingModal.close();
        });
    }
  }

  setBidListMultiRemoveSuccessBanner(numOfVehiclesRemoved: number) {
    if (numOfVehiclesRemoved > 0) {
      this.translocoService.selectTranslate('vehicles.bidlistInventoryItem.textSuccessfullyRemovedMulti', {
        numOfVehiclesRemoved: numOfVehiclesRemoved
      }).pipe(take(1)).subscribe(translate => {
        this.bidlistInventoryItemTranslations.textSuccessfullyRemoved = translate;
      });

      const bidListMultiRemoveSuccess = {
        text: this.bidlistInventoryItemTranslations.textSuccessfullyRemoved,
        showErrorIcon: false,
        showIcon: true,
        showUndo: false,
        showSuccessIcon: true,
        mode: 'confirmation'
      };

      this.bidListMultiRemoveSuccess = bidListMultiRemoveSuccess;
    }
  }

  closeBidListMultiRemoveSuccess() {
    this.bidListMultiRemoveSuccess = null;
  }


  setBidListMultiRemoveErrorBanners(failedAuctionItems: BidListMultiRemoveResponseDto) {
    const removalFailedList = failedAuctionItems.removalFailedList;

    // the following errors in the set generate specific error message banners
    // mapping in case more error translations are required later
    const setErrors = new Set<string>(['F-REMPLT-AIS-BDLREM']);
    const translationCodeMapping: { [k: string]: any } = {};

    removalFailedList.forEach((failedAuctionItem: BidListItemsRemoveFailed) => {
      // if the failed auction item does not return a VIN - do not include it in the error banner generation
      // this can occur in the case where a user attempts to remove a vehicle from their bid list, but that vehicle
      // was already removed from SmartAuction such as when a user has a stale browser window
      if (failedAuctionItem.vin) {
        let failedAuctionItemErrorCode = failedAuctionItem.errors[0].code;
        // provide a generic error if the error code isn't in the specific list of errors.
        // genericError text maps to the translation
        if (!setErrors.has(failedAuctionItemErrorCode)) {
          failedAuctionItemErrorCode = 'genericError';
        }
        if (translationCodeMapping[failedAuctionItemErrorCode]) {
          translationCodeMapping[failedAuctionItemErrorCode].failedVins.push(failedAuctionItem.vin);
        }
        else {
          translationCodeMapping[failedAuctionItemErrorCode] = { 'failedVins': [failedAuctionItem.vin] };
        }
      }
    });

    // generate error banners text
    for (const errorType in translationCodeMapping) {
      const vinList = translationCodeMapping[errorType]?.failedVins;
      this.translocoService.selectTranslate(`error.bidListMultiRemoveBanner.${errorType}`, {
        vins: vinList.join(', ')
      }).pipe(take(1)).subscribe(translate => {
        this.bidListMultiRemoveError.push({
          text: translate,
          showErrorIcon: true,
          showIcon: true,
          showUndo: false,
          showSuccessIcon: false,
          mode: 'confirmation'
        });
      });
    }
    this.changeDetector.markForCheck();
  }

  closeBidListMultiRemoveError(index) {
    this.bidListMultiRemoveError.splice(index, 1);
  }

  hasBeenRemoved(auctionItemUuid: string) {
    return this.removedUuids.getValue().includes(auctionItemUuid) && this.multiVehicleRemovalEnabled;
  }

  toggleBidListMultiSelect() {
    this.vehicleSelectAll = this.bidListMultiSelectEnabled;
    this.bidListMultiSelectEnabled = !this.bidListMultiSelectEnabled;
    this.bidListSelectAll = this.bidListMultiSelectEnabled;
    this.selectAllBidListVehiclesToggle();
  }

  getVdpRefactorFlag(): boolean {
    return this.launchDarklyService.getFeatureFlag('vdp-AIRefactorEnabled', false);
  }

  get bidListSelectAllButtonText(): string {
    return `vehicles.bidList.${this.bidListMultiSelectEnabled ? 'labelRemoveSingleVehicleButton' : 'labelSelectAllVehiclesButton'}`;
  }

  get bidListSelectAllButtonAnalytics(): string {
    return this.bidListMultiSelectEnabled ? 'Select all vehicles' : 'Deselect all vehicles';
  }

  get isDeclineEnabled() {
    return !this.inServiceVehicleEnabled || 'ACP' === this.commonListTypeService.getVehicleTypeCodeFilterForCurrentSharedList();
  }

  analyticsVehiclesRemoved(auctionItemUuids: string[]) {
    this.analyticsService.track('customEvent', {
      name: 'removeBidListMultiBuyAction',
      type: 'CustomEvent',
      category: 'UserInteraction:CustomEvent',
      attr: {
        'vehicleUuids': auctionItemUuids,
        'numVehicles': auctionItemUuids.length
      },
    });
  }
}
